/* eslint-disable prettier/prettier */
/* eslint-disable */
/* prettier-ignore-file */
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useHeader } from '../context/HeaderContext';
import { UserProfileCard } from '../components/pageComponents/managerUsers/UserProfileCard';
import { UserData } from '../types/manageUsers';
import InviteUserForm from '../components/pageComponents/managerUsers/InviteUserForm';
import DeleteAccountModal from '../components/pageComponents/managerUsers/DeleteAccountModal';
import iconlogout from '../assets/icons/deleteimg.png';
import CoachManageUsersSearchbar from '../components/pageComponents/managerUsers/CoachManageUsersSearchbar';
import MultiSelectDropdown from '../components/pageComponents/managerUsers/MultiSelectDropdown';
// import ManageUsers, { User } from '../components/pageComponents/managerUsers/ManageUsers';
import styles from '../styles/pages/ManageUsersPage.module.css';
import addIcon from '../assets/profile/invite.png';
import exportt from '../assets/profile/export.png';
import profile from '../assets/profile/profile.svg';
// import { useCoachCourseDashboard } from '../hooks/useCoachCourseDashboard';
import { useAdminDashboard } from '../hooks/useAdminDashboard';
import { useUserProfile } from '../hooks/useUserProfile';
import profileDefault from '../assets/profile/profile.svg';
import { useCourseEnrollment } from '../hooks/useCourseEnrollment';
import { useCourseCatalog } from '../hooks/useCourse';
import SuccessContent from '../components/controlVariations/ModularSuccessModal';
import ResponsiveModal from '../components/controlVariations/ResponsiveModal';
import ManageUsersAdmin, {
	User,
} from '../components/pageComponents/managerUsers/ManageUsersAdmin';
import { useInvitation } from '../hooks/useInvitation';
import {
	validateFullNameUI,
	validateEmail,
	validateOrganizationName,
} from '../utils/validation'; // adjust path
import {
	validatePhoneNumber,
	formatPhoneNumber,
} from '../utils/validationSchema';
import { useRoles } from '../hooks/useRoles';
import { useAdminUser } from '../hooks/useAdminUser';
import { useAdminUserList } from '../hooks/useAdminUserList';
import { useAddFacultyToProgram } from '../hooks/useCourse'; // adjust path
import {
	useRemoveFacultyFromProgram,
	useRemoveProgramOwner,
} from '../hooks/useCourse';

// import styles from '../styles/pages/ManageUsersPage.module.css';
const dummyUser = {
	name: 'John Doe',
	email: 'john.doe@gmail.com',
	phone: '+91 9876543210',
	timezone: 'UTC +05:30',
	location: 'Mumbai, Maharashtra',
	country: 'India',
	program: 'IMPACT Level 1 ACC',
	role: 'Coachee',
	organization: 'ABC Pvt Ltd',
	professionalRole: 'Assistant Manager',
	areasOfInterest: ['ICF Coaching Credentials', 'Mentor', 'Mentoring'],
	coachingExperience: ['Personal Growth', 'Leadership Effectiveness'],
	growthWithIOCM: ['Building Coaching Capability'],
	avatarUrl: profile,
};

const ManageUsersAdminPage: React.FC = () => {
	const { setHeaderContent } = useHeader();
	const { updateUserById, loading: roleLoading } = useAdminUser();
	const { roles, loading: rolesLoading } = useRoles();
	// const { dashboard, loading, error, fetchDashboard } = useCoachCourseDashboard();
	const { dashboard, loading, error, fetchDashboard } = useAdminDashboard();
	const { addFaculty, isLoading: facultyLoading } = useAddFacultyToProgram();
	const {
		usersData,
		loading: usersLoading,
		error: usersError,
		fetchUsers,
	} = useAdminUserList();
	const {
		profile,
		fetchUserProfileById,
		loading: profileLoading,
		deleteUser,
		deleteCoach,
		deleteLoading,
		deleteError,
		deleteSuccess,
	} = useUserProfile();

	const {
		deleteEnrollment,
		createEnrollment,
		isDeleting: enrollmentDeleting,
	} = useCourseEnrollment();

	const [activeTab, setActiveTab] = useState<
		'all' | 'learner' | 'invitee' | 'coach' | 'guest'
	>('all');

	const { courses: catalogCourses } = useCourseCatalog();
	const {
		createInvite,
		cancelInvite,
		loading: inviteLoading,
	} = useInvitation();
	const { removeFaculty, isLoading: removeFacultyLoading } =
		useRemoveFacultyFromProgram();
	const { removeOwner } = useRemoveProgramOwner();

	const [pendingRemovalPrograms, setPendingRemovalPrograms] = useState<
		string[]
	>([]);

	const [errors, setErrors] = useState({
		fullName: '',
		email: '',
		phoneNumber: '',
		organizationName: '',
		enrolledPrograms: '', // ✅ NEW
		platformRole: '', // ✅ NEW
	});

	useEffect(() => {
		setHeaderContent(<p>Manage Users</p>);
	}, [setHeaderContent]);

	//   useEffect(() => {
	//   fetchDashboard(); // fetch all courses with attendees
	// }, []);
	// useEffect(() => {
	//   fetchUsers({
	//     page: 1,
	//     limit: 100,
	//   });
	// }, []);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(90);
	useEffect(() => {
		fetchUsers({
			page,
			limit,
		});
	}, [page, limit]);

	const [mode, setMode] = useState<'view' | 'edit'>('view');
	const [userData, setUserData] = useState<UserData>(dummyUser);

	const [values, setValues] = useState({
		fullName: '',
		email: '',
		phoneNumber: '',
		organizationName: '',
		enrolledPrograms: '',
		platformRole: '',
	});

	
	const handleChange = (field: any, value: any) => {
		
		let updatedValue = value;

		// ✅ FORMAT PHONE NUMBER
		if (field === 'phoneNumber') {
			updatedValue = formatPhoneNumber(value); // 🔥 apply formatting
		}

		// ✅ SET VALUE
		setValues(prev => ({
			...prev,
			[field]: updatedValue,
		}));

		// 🔥 LIVE VALIDATION
		let error = '';

		if (field === 'fullName') {
			error = validateFullNameUI(value);
		}

		if (field === 'email') {
			error = validateEmail(value);
		}
		if (field === 'phoneNumber') {
			error = validatePhoneNumber(value) || '';
		}
		if (field === 'organizationName') {
			error = validateOrganizationName(value);
		}

		setErrors(prev => ({
			...prev,
			[field]: error,
		}));
	};

	
	const [open, setOpen] = useState(false);

	const [checked, setChecked] = useState<boolean | 'indeterminate'>(false);
	

	const [selectedUser, setSelectedUser] = useState<User | null>(null);

	const [isInviteOpen, setIsInviteOpen] = useState(false);

	const mapRole = (roleName?: string): User['role'] => {
		if (!roleName) return null;

		const role = roleName.toLowerCase();

		if (role === 'coachee') return 'learner';
		if (role === 'coach') return 'coach';
		if (role === 'guest') return 'guest';

		return null;
	};

	console.log('Dashboard data:', dashboard);

	const BASE_URL = 'https://your-api-domain.com';

	const apiUsers: User[] = React.useMemo(() => {
		if (!usersData?.users) return [];

		return usersData.users
			.filter((u: any) => u.rolename?.toLowerCase() !== 'superadmin')
			.map((u: any) => {
				const isInvitee = u.rowtype === 'invitee';

				return {
					id: u.id,
					fullName: u.fullname,
					avatarUrl: u.profilepicture || profileDefault,

					enrolledProgram: u.programs?.length
						? u.programs
								.map((p: any) => p.title.split('(')[0].trim())
								.join(', ')
						: 'No Program',

					programs: u.programs || [],

					iccCredentials: u.icfcredentials || 'N/A',
					email: u.email,
					// ✅ 🔥 FIX: FORCE invitee role
					role: isInvitee
						? 'invitee'
						: mapRole(u.rolename) || u.rolename,

					status: isInvitee
						? u.inviteinfo?.invitestatus || u.accountstatus
						: u.accountstatus,

					type: isInvitee ? 'invitee' : 'user',

					enrollmentIds:
						u.programs?.map((p: any) => p.enrollmentid) || [],
				};
			});
	}, [usersData]);

	const mapApiResponseToUserData = (
		apiData: any,
		enrolledProgram?: string
	): UserData => ({
		name: apiData.fullname || '',
		email: apiData.email || '',
		phone: apiData.phonenumber || '',
		timezone: apiData.preferences?.timezone || 'UTC',
		location: apiData.location || '',
		country: apiData.country,
		enrolledProgram: enrolledProgram || '',
		platformRole: mapRole(apiData.rolename) || apiData.rolename || 'null',
		organization: apiData.organizationname || '',
		professionalRole: apiData.designation || '',
		areasOfInterest: apiData.areasofinterest || [],
		coachingExperience: apiData.coachingexperience || [],
		growthWithIOCM: apiData.growthparameters || [],
		avatarUrl: apiData.profilepicture || profileDefault,
	});

	const [search, setSearch] = useState('');
	const [searchError, setSearchError] = useState('');
	const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);
	const [selectedCredentials, setSelectedCredentials] = useState<string[]>(
		[]
	);

	

	const programOptions = React.useMemo(() => {
		if (!catalogCourses?.length) return [];

		const uniquePrograms = new Map();

		catalogCourses
			.filter(course => course.status?.toLowerCase() === 'published')
			.forEach(course => {
				const trimmedTitle = course.title.split('(')[0].trim();

				if (!uniquePrograms.has(trimmedTitle)) {
					uniquePrograms.set(trimmedTitle, {
						label: trimmedTitle,
						value: course.id,
					});
				}
			});

		return Array.from(uniquePrograms.values());
	}, [catalogCourses]);

	const programOptionsForInvite = programOptions;

	// const programOptionsForFilter = programOptions.map(p => ({
	// 	label: p.label,
	// 	value: p.label, // 👈 IMPORTANT
	// }));
	const programOptionsForFilter = [
  {
    label: 'No Program',
    value: 'NO_PROGRAM',
  },
  ...programOptions.map(p => ({
    label: p.label,
    value: p.label,
  })),
];

	const roleOptions = React.useMemo(() => {
		if (!roles) return [];

		return roles
			.filter(role =>
				['coach', 'coachee'].includes(role.name.toLowerCase())
			)
			.map(role => ({
				// label: role.name,
				label:
					role.name.toLowerCase() === 'coachee'
						? 'Learner'
						: role.name,
				value: role.id,
			}));
	}, [roles]);

	const filteredUsers = apiUsers
		.filter(user => {
			const normalizedSearch = search.trim().toLowerCase();

			if (user.role === 'invitee' && user.status !== 'pending') {
				return false;
			}

			// const programMatch =
			//   selectedPrograms.length === 0 ||
			//   (user.enrolledProgram && selectedPrograms.includes(user.enrolledProgram));
			// const programMatch =
			// 	selectedPrograms.length === 0 ||
			// 	user.programs?.some((p: any) => {
			// 		const programName = p.title.split('(')[0].trim();
			// 		return selectedPrograms.includes(programName);
			// 	});
			const programMatch =
	selectedPrograms.length === 0 ||
	(selectedPrograms.includes('NO_PROGRAM')
		? user.enrolledProgram === 'No Program'
		: user.programs?.some((p: any) => {
				const programName = p.title.split('(')[0].trim();

				return selectedPrograms.includes(programName);
			}));

			const credentialMatch =
				selectedCredentials.length === 0 ||
				(user.iccCredentials &&
					selectedCredentials.includes(user.iccCredentials)) ||
				(!user.iccCredentials && selectedCredentials.includes('N/A'));

			const searchMatch = user.fullName
				?.toLowerCase()
				.includes(normalizedSearch);

			return programMatch && credentialMatch && searchMatch;
		})
		.filter(user => {
			if (activeTab === 'learner') return user.role === 'learner';
			if (activeTab === 'coach') return user.role === 'coach';
			// if (activeTab === "invitee") return !user.role || user.role === "invitee";
			// if (activeTab === "invitee") return user.role === "invitee";
			if (activeTab === 'invitee') {
				return user.role === 'invitee' && user.status === 'pending';
			}
			if (activeTab === 'guest') return user.role === 'guest';
			return true;
		});

	const credentialOptions = [
		{ label: 'ACC', value: 'ACC' },
		{ label: 'PCC', value: 'PCC' },
		{ label: 'MCC', value: 'MCC' },
		{ label: 'EMCC', value: 'EMCC' },
		{ label: 'N/A', value: 'N/A' },
	];

	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const [profileMode, setProfileMode] = useState<'view' | 'edit'>('view');

	const [successState, setSuccessState] = useState<{
		open: boolean;
		title: string;
		subtitle: string;
	}>({
		open: false,
		title: '',
		subtitle: '',
	});

	const [isOnline, setIsOnline] = useState(navigator.onLine);

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	const hasEnrollment =
		selectedUser?.enrolledProgram &&
		selectedUser.enrolledProgram !== 'No Program';

	// const showCheckbox =
	//   selectedUser?.role !== "invitee" &&
	//   selectedUser?.role !== "guest" &&
	//   !(selectedUser?.role === "learner" && !hasEnrollment);
	const showCheckbox =
		selectedUser?.role !== 'invitee' &&
		selectedUser?.role !== 'guest' &&
		!(
			(selectedUser?.role === 'learner' && !hasEnrollment) ||
			(selectedUser?.role === 'coach' && !hasEnrollment)
		);

	const handleConfirmDelete = async () => {
		if (!selectedUser) return;

		if (!isOnline) return;

		if (pendingRemovalPrograms.length > 0) {
			// ✅ COACH PROGRAM REMOVAL
			if (selectedUser.role === 'coach') {
				//   for (const program of pendingRemovalPrograms) {
				//   const courseId =
				//     programOptions.find((p) => p.label === program)?.value;

				//   if (!courseId) continue;

				//   await removeFaculty(courseId, selectedUser.id);
				// }
				for (const programName of pendingRemovalPrograms) {
					const programObj = selectedUser.programs?.find(
						p => p.title.split('(')[0].trim() === programName
					);

					if (!programObj) continue;

					const courseId = programObj.id;

					// 🔥 OWNER
					if (programObj.relationship === 'owner') {
						await removeOwner(courseId);
					}

					// 🔥 FACULTY
					if (programObj.relationship === 'faculty') {
						await removeFaculty(courseId, selectedUser.id);
					}
				}

				setOpen(false);
				setIsProfileOpen(false);

				setSuccessState({
					open: true,
					title: 'Coach updated',
					subtitle: `${selectedUser.fullName} removed from selected programs.`,
				});

				setPendingRemovalPrograms([]);

				setTimeout(() => {
					setSuccessState(prev => ({ ...prev, open: false }));
					fetchUsers({ page, limit });
				}, 3000);

				return;
			}

			// ✅ LEARNER (EXISTING LOGIC - unchanged)
			for (const program of pendingRemovalPrograms) {
				const enrollmentId = selectedUser?.enrollmentIds?.find(
					(id, index) => {
						const programName = selectedUser.enrolledProgram
							?.split(',')
							[index]?.trim();

						return programName === program;
					}
				);

				if (enrollmentId) {
					await deleteEnrollment(enrollmentId);
				}
			}

			setOpen(false);
			setIsProfileOpen(false);

			setSuccessState({
				open: true,
				title: 'Program Removed',
				subtitle: `${pendingRemovalPrograms.join(', ')} removed successfully.`,
			});

			setPendingRemovalPrograms([]);

			setTimeout(() => {
				setSuccessState(prev => ({ ...prev, open: false }));
				fetchUsers({ page, limit });
			}, 3000);

			return;
		}

		try {
			let title = '';
			let subtitle = '';

			// ✅ 🔥 CASE 1: INVITEE → CALL CANCEL INVITE API
			if (selectedUser.role === 'invitee') {
				await cancelInvite(selectedUser.id);

				title = 'Invitation cancelled';
				subtitle = `${selectedUser.fullName}'s invitation has been cancelled.`;
			}

			// ✅ GUEST → ALWAYS HARD DELETE
			else if (selectedUser.role === 'guest') {
				await deleteUser(selectedUser.id, 'Guest user deletion');

				title = 'User deleted';
				subtitle = `${selectedUser.fullName}'s account was permanently removed.`;
			}

			// ✅ 🔥 CASE 2: NORMAL USERS + COACH (UPDATED)
			else {
				if (selectedUser.role === 'coach') {
					const isCoachWithoutPrograms =
						!selectedUser.enrolledProgram ||
						selectedUser.enrolledProgram === 'No Program';

					// ✅ NEW: Coach without program → HARD DELETE directly
					if (isCoachWithoutPrograms) {
						await deleteUser(
							selectedUser.id,
							'Coach deleted (no program)'
						);

						title = 'Coach deleted';
						subtitle = `${selectedUser.fullName}'s account was permanently removed.`;
					}

					// ✅ EXISTING LOGIC (unchanged)
					else if (checked === true) {
						await deleteUser(
							selectedUser.id,
							'Coach hard deletion'
						);

						title = 'Coach deleted';
						subtitle = `${selectedUser.fullName}'s account was permanently removed.`;
					} else {
						// await deleteCoach(selectedUser.id, "Coach removed by admin");
						// const programs = selectedUser.enrolledProgram
						//   ?.split(",")
						//   .map((p) => p.trim()) || [];
						const programs = selectedUser.programs || [];

						for (const program of programs) {
							// const courseId =
							//   programOptions.find((p) => p.label === program)?.value;

							// if (!courseId) continue;

							// await removeFaculty(courseId, selectedUser.id);
							const courseId = program.id;

							// 🔥 OWNER → remove owner
							if (program.relationship === 'owner') {
								await removeOwner(courseId);
							}

							// 🔥 FACULTY → remove faculty
							if (program.relationship === 'faculty') {
								await removeFaculty(courseId, selectedUser.id);
							}
						}

						title = 'Coach removed';
						subtitle = `${selectedUser.fullName} was removed and all associations cleaned.`;
					}
				}

				// ✅ EXISTING LOGIC (UNCHANGED for others)
				else {
					if (checked === true) {
						await deleteUser(
							selectedUser.id,
							'User requested deletion'
						);

						title = 'User deleted';
						subtitle = `${selectedUser.fullName}'s account and personal data were permanently removed.`;
					} else {
						if (selectedUser.enrollmentIds?.length) {
							for (const id of selectedUser.enrollmentIds) {
								await deleteEnrollment(id);
							}
						}

						title = 'Enrollment removed';
						subtitle = `${selectedUser.fullName} was successfully removed from the program.`;
					}
				}
			}

			setOpen(false);
			setIsProfileOpen(false);

			setSuccessState({
				open: true,
				title,
				subtitle,
			});

			setTimeout(() => {
				setSuccessState(prev => ({ ...prev, open: false }));
				fetchDashboard();
				fetchUsers({ page, limit }); // 🔥 ADD THIS
			}, 3000);
		} catch (err: any) {
			console.log(err.message);
		}
	};

	const handleExport = () => {
		if (!filteredUsers || filteredUsers.length === 0) return;

		const exportData = filteredUsers.map(user => ({
			Name: user.fullName,
			Email: user.email || 'N/A',
			Program: user.enrolledProgram,
			Credential: user.iccCredentials,
			Role: user.role ?? 'Invitee',
		}));

		// convert JSON → worksheet
		const worksheet = XLSX.utils.json_to_sheet(exportData);

		// create workbook
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');

		// generate excel buffer
		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		});

		const data = new Blob([excelBuffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		});

		saveAs(data, 'ManageUsers.xlsx');
	};

	const handleSubmit = async () => {
		const fullNameError = validateFullNameUI(values.fullName);
		const emailError = validateEmail(values.email);
		const phoneError = validatePhoneNumber(values.phoneNumber) || '';
		const orgError = validateOrganizationName(values.organizationName);

		const programError =
			values.enrolledPrograms.length === 0
				? 'Please select at least one program'
				: '';

		const roleError = !values.platformRole ? 'Please select a role' : '';

		if (
			fullNameError ||
			emailError ||
			phoneError ||
			programError ||
			roleError ||
			orgError
		) {
			setErrors({
				fullName: fullNameError,
				email: emailError,
				phoneNumber: phoneError,
				organizationName: orgError,
				enrolledPrograms: programError,
				platformRole: roleError,
			});
			return;
		}
		const selectedRole = roles.find(
    role => role.id === values.platformRole
);
const invitetype =
    selectedRole?.name.toLowerCase() === 'coachee'
        ? 'coach-coachee'
        : selectedRole?.name.toLowerCase() === 'coach'
            ? 'coach-mentee'
            : undefined;

		try {
			const payload = {
				fullname: values.fullName,
				email: values.email,
				phonenumber: values.phoneNumber || undefined,
				organizationname: values.organizationName || undefined,
				relatedcourseid: values.enrolledPrograms,
				// invitetype: values.platformRole,
				roleid: values.platformRole,
				invitetype: invitetype,
			};

		

const res = await createInvite(payload);

if (!res.success) {
    setErrors(prev => ({
        ...prev,
        email: res.message,
    }));

    setIsInviteOpen(true);
    return;
}



			// ✅ CLOSE INVITE MODAL
			setIsInviteOpen(false);

			// ✅ SHOW SUCCESS MODAL
			setSuccessState({
				open: true,
				title: 'Invitation sent',
				subtitle: `${values.fullName} has been invited successfully.`,
			});

			// ⏳ AUTO CLOSE AFTER 3 SECONDS
			setTimeout(() => {
				setSuccessState(prev => ({
					...prev,
					open: false,
				}));
			}, 3000);

			// ✅ RESET FORM
			setValues({
				fullName: '',
				email: '',
				phoneNumber: '',
				organizationName: '',
				enrolledPrograms: '',
				platformRole: '',
			});

			// ✅ REFRESH DATA
			fetchDashboard();
			fetchUsers({ page, limit });
		} catch (err: any) {
       
    console.error(err);
}
	};

	// const inviteRoleOptions = [
	// 	{ label: 'Coach', value: 'coach-mentee' },
	// 	{ label: 'Learner', value: 'coach-coachee' },
	// ];
	const inviteRoleOptions = React.useMemo(() => {
	return roles
		.filter(role =>
			['coach', 'coachee'].includes(role.name.toLowerCase())
		)
		.map(role => ({
			label:
				role.name.toLowerCase() === 'coachee'
					? 'Learner'
					: role.name,
			value: role.id,
		}));
}, [roles]);

	const handleSaveUserProfile = async (updatedData: UserData) => {
		
		setUserData(updatedData);

		try {
			let updatedRoleName: string | undefined =
				selectedUser?.role ?? undefined;

			// ✅ GUEST → UPDATE ROLE
			if (selectedUser?.role === 'guest') {
				const selectedRole = roleOptions.find(
					role => role.value === updatedData.platformRole
				);

				if (!selectedRole) {
					throw new Error('Invalid role selected');
				}

				await updateUserById(selectedUser.id, {
					roleid: selectedRole.value,
					accountstatus: 'active',
				});

				updatedRoleName = selectedRole.label.toLowerCase(); 

				// 🔥 NEW: REFETCH USER AFTER ROLE UPDATE
				const freshUser = await fetchUserProfileById(selectedUser.id);

				if (freshUser) {
					const mappedData = mapApiResponseToUserData(
						freshUser,
						updatedData.enrolledProgram
					);

					setUserData(mappedData);

					// 🔥 IMPORTANT: update selectedUser role
					setSelectedUser(prev => {
						if (!prev) return prev;

						return {
							...prev,
							role:
								updatedRoleName === 'coachee'
									? 'learner'
									: updatedRoleName === 'coach'
										? 'coach'
										: updatedRoleName === 'guest'
											? 'guest'
											: prev.role,
						};
					});
				}
			}

			// ✅ LEARNER LOGIC (UNCHANGED)
			else if (selectedUser?.role === 'learner') {
				const selectedProgramsToEnroll = updatedData.enrolledProgram
					? updatedData.enrolledProgram
							.split(',')
							.map((p: string) => p.trim())
					: [];

				for (const program of selectedProgramsToEnroll) {
					const alreadyEnrolled = selectedUser.enrolledProgram
						?.split(',')
						.map(p => p.trim())
						.includes(program);

					if (alreadyEnrolled) continue;

					const payload = {
						courseid:
							programOptions.find(p => p.label === program)
								?.value || program,
						userid: selectedUser.id,
					};

					await createEnrollment(payload);
				}
			}

			// ✅ COACH LOGIC (UNCHANGED)
			else if (selectedUser?.role === 'coach') {
				const selectedPrograms = updatedData.enrolledProgram
					? updatedData.enrolledProgram
							.split(',')
							.map((p: string) => p.trim())
					: [];

				for (const program of selectedPrograms) {
					const alreadyAssigned = selectedUser.enrolledProgram
						?.split(',')
						.map(p => p.trim())
						.includes(program);

					if (alreadyAssigned) continue;

					const courseId =
						programOptions.find(p => p.label === program)?.value ||
						program;

					await addFaculty(courseId, {
						userid: selectedUser.id,
						facultyrole: 'faculty',
						displayorder: 0,
					});
				}
			}

			// ✅ SUCCESS MODAL
			setSuccessState({
				open: true,
				title: 'Profile Updated',
				subtitle: `${updatedData.name}'s profile has been updated successfully.`,
			});

			// ✅ ALWAYS CLOSE PROFILE (FIXED)
			setIsProfileOpen(false);
			setProfileMode('view');

			// ⏳ Refresh + auto close success
			setTimeout(() => {
				setSuccessState(prev => ({ ...prev, open: false }));

				fetchDashboard();
				fetchUsers({ page, limit });
			}, 3000);
		} catch (err: any) {
			console.error('Save error:', err);
		}
	};

	const resetInviteForm = () => {
	setValues({
		fullName: '',
		email: '',
		phoneNumber: '',
		organizationName: '',
		enrolledPrograms: '',
		platformRole: '',
	});

	setErrors({
		fullName: '',
		email: '',
		phoneNumber: '',
		organizationName: '',
		enrolledPrograms: '',
		platformRole: '',
	});
};

 const deleteModalTitle =
	selectedUser?.role === 'guest' ||
	((selectedUser?.role === 'learner' ||
		selectedUser?.role === 'coach') &&
		!hasEnrollment)
		? `Are you sure you want to remove ${selectedUser?.fullName}?`
		: `Are you sure to remove ${selectedUser?.fullName} from the program?`;

	return (
		<>
			{/* ===== HEADER ===== */}
			<div className={styles.header}>
				{/* LEFT SIDE */}
				<div className={styles.leftSection}>
					<div className={styles.leftSectionSerach}>
						<CoachManageUsersSearchbar
							value={search}
							onChange={e => {
								const value = e.target.value;

								// Allow only letters and spaces
								const isValid = /^[a-zA-Z\s]*$/.test(value);

								if (isValid) {
									setSearch(value);
									setSearchError(''); // clear error
								} else {
									setSearchError(
										'Only letters and spaces are allowed'
									);
								}
							}}
						/>
						{searchError && (
							<p className={styles.searchError}>{searchError}</p>
						)}
					</div>

					<div className={styles.dropdown}>
						<MultiSelectDropdown
							options={programOptionsForFilter}
							selectedValues={selectedPrograms}
							onChange={setSelectedPrograms}
							placeholder="Program"
							width="209px"
						/>

						<MultiSelectDropdown
							options={credentialOptions}
							selectedValues={selectedCredentials}
							onChange={setSelectedCredentials}
							placeholder="ICC Credentials"
							width="209px"
						/>
					</div>
				</div>

				{/* RIGHT SIDE */}
				<div className={styles.right}>
					<button
						className={styles.exportButton}
						onClick={handleExport}
					>
						Export data{' '}
						<img
							src={exportt}
							alt=""
							className={styles.inviteButtonicon}
						/>
					</button>
					<button
						className={styles.inviteButton}
						onClick={() => setIsInviteOpen(true)}
					>
						Send Invites{' '}
						<img
							src={addIcon}
							alt=""
							className={styles.inviteButtonicon}
						/>
					</button>
				</div>
			</div>

			{loading && <p>Loading users...</p>}
			{error && <p style={{ color: 'red' }}>{error}</p>}
			<ManageUsersAdmin
				users={filteredUsers}
				pageSize={10}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				onView={async user => {
					setSelectedUser(user);
					setProfileMode('view');
					setIsProfileOpen(true);

					try {
						const apiResponse = await fetchUserProfileById(user.id); // returns LearnerProfile

						if (apiResponse) {
							// Map API response to UserData format
							console.log('particular user data ', apiResponse);
							const mappedData = mapApiResponseToUserData(
								apiResponse,
								user.enrolledProgram
							);

							setUserData(mappedData); // now UserProfileCard will show real data
						}
					} catch (err) {
						console.error('Error fetching user profile:', err);
					}
				}}
				onDelete={user => {
					console.log('DELETE CLICKED', user); // debug

					setSelectedUser(user); // store user
					setChecked(false); // reset checkbox
					setOpen(true); // open delete modal
				}}
			/>
			<DeleteAccountModal
				open={open}
				icon={iconlogout}
			title={deleteModalTitle}
				confirmText="Remove User"
				// showCheckbox={selectedUser?.role !== "invitee"}
				showCheckbox={showCheckbox}
				cancelText="Keep Account"
				onConfirm={handleConfirmDelete}
				onCancel={() => setOpen(false)}
				checkboxLabel="Delete the user from the platform"
				checkboxChecked={checked}
				onCheckboxChange={setChecked}
				// disableConfirm={!isOnline}
				disableConfirm={
					!isOnline || deleteLoading || enrollmentDeleting
				}
			/>
			

			{isInviteOpen && (
				<div className={styles.modalOverlay}>
					<div className={styles.modalContent}>
						<InviteUserForm
							title="Send Invite"
							onClose={() => {
	                  	     resetInviteForm();
		                    setIsInviteOpen(false);
	                            }}
							values={values}
							errors={errors}
							programOptions={programOptionsForInvite}
							roleOptions={inviteRoleOptions}
							onChange={handleChange}
							onSubmit={handleSubmit}
						/>
					</div>
				</div>
			)}

			{isProfileOpen && selectedUser && (
				
				<UserProfileCard
					mode={profileMode}
					title={
						profileMode === 'view'
							? 'View User Profile'
							: 'Edit User Profile'
					}
					programOptions={programOptionsForInvite}
					roleOptions={roleOptions}
					data={userData} // you can replace with mapped selectedUser data
					showEdit={true}
					showDelete={true}
					showClose={true}
					showSave={true}
					onEdit={() => setProfileMode('edit')}
					onClose={() => setIsProfileOpen(false)}
					onDelete={removedPrograms => {
						setPendingRemovalPrograms(removedPrograms || []);
						setChecked(false);
						setOpen(true);
					}}
					onUndo={() => setProfileMode('view')}
					onSave={handleSaveUserProfile}
				/>
			)}

			{successState.open && (
				<div className={styles.modalOverlay}>
					<ResponsiveModal
						open={successState.open}
						onClose={() =>
							setSuccessState(prev => ({ ...prev, open: false }))
						}
					>
						<SuccessContent
							title={successState.title}
							subtitle={successState.subtitle}
						/>
					</ResponsiveModal>

				</div>
				
			)}
		</>
	);
};

export default ManageUsersAdminPage;
